'use strict';

const mapState = require('vuex').mapState;

module.exports = {
    computed: {
        ...mapState('orderSummary', {
            giftWrapResources: state => state.resources,
            giftWrapData: state => state.giftWrapData
        })
    },
    methods: {
        showGiftwrapInfoModal(giftWrapModalText, giftWrapModalTitle, giftWrapModalButtonText) {
            window.eventBus.$emit('shouldOpenModal', {
                resources: {
                    heading: giftWrapModalTitle,
                    headingLarge: true
                },
                paragraphs: [
                    {
                        text: giftWrapModalText
                    }
                ],
                buttons: [
                    {
                        type: 'btn',
                        label: giftWrapModalButtonText,
                        shouldCloseModal: true
                    }
                ],
                row: {
                    class: 'center-align'
                },
                closeElement: {
                    shouldCloseModal: true
                },
                ctaHolder: {},
                modalFullWidth: false,
                modalLarge: true
            });
        }
    }
};
